import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const DAY = 86400000;

export function tenureLabel(since, now = Date.now()) {
  const t = since ? new Date(since).getTime() : NaN;
  if (!Number.isFinite(t)) return null;
  const weeks = Math.floor((now - t) / (7 * DAY));
  if (weeks < 1) return 'NEW';
  if (weeks < 4) return `${weeks} Week${weeks === 1 ? '' : 's'}`;
  if (weeks === 52) return '1 Year';
  if (weeks > 52) return `${weeks} Weeks`;
  const months = Math.max(1, Math.floor(weeks / 4.345));
  return `${months} Month${months === 1 ? '' : 's'}`;
}

export function MegaTierTenureBadge({ ticker, since }) {
  const [open, setOpen] = useState(false);
  const label = tenureLabel(since);
  if (!label) return null;
  const isNew = label === 'NEW';
  const sinceDate = new Date(since).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const days = Math.floor((Date.now() - new Date(since).getTime()) / DAY);
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`inline-flex items-center gap-0.5 text-[9px] font-bold px-1 rounded border transition-colors ${isNew
          ? 'bg-emerald-500/15 text-emerald-500 border-emerald-500/40 hover:bg-emerald-500/25'
          : 'bg-muted text-muted-foreground border-border hover:border-amber-500/60 hover:text-foreground'}`}
        title={isNew ? 'Entered the Elite list since the previous run' : `On the Elite list since ${sinceDate}`}
        data-testid={`mega-tier-tenure-${ticker}`}
      >
        {isNew && <Sparkles className="w-2.5 h-2.5" />}{label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" onClick={(e) => e.stopPropagation()} data-testid={`mega-tier-tenure-modal-${ticker}`}>
          <DialogHeader>
            <DialogTitle>{ticker} · {isNew ? 'New this week' : `${label} on the Elite list`}</DialogTitle>
            <DialogDescription className="text-sm text-foreground/85 pt-2 space-y-2">
              <span className="block">
                {isNew
                  ? `${ticker} entered the Mega Tier Elite list on ${sinceDate} — it was not on the list after the previous run.`
                  : `${ticker} has been on the Mega Tier Elite list continuously since ${sinceDate} (${days} days).`}
              </span>
              <span className="block text-muted-foreground text-xs">
                The list is recomputed weekly from annual filings. A stock keeps its tenure only while it passes all three stages every run;
                if it drops off and later returns, the count starts over. Labels: NEW (under a week) → Weeks → Months → 1 Year → then Weeks again (e.g. 53 Weeks).
              </span>
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
